// import Autosuggest from 'react-autosuggest'
import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import { chain } from 'lodash'
import moment from 'moment'
import config from '../../config'
import Loader from 'react-loader'
import CSSModules from 'react-css-modules'
import format from '../../helpers/format'
import { asyncConnect } from 'redux-async-connect'
// import Helmet from 'react-helmet'
import container from '../../helpers/container'
import convert from '../../helpers/convert'
import analytics from '../../helpers/analytics'
// import Modal from 'react-modal'
import {SlideDown} from 'react-slidedown'
import {Row, Col} from 'react-flexbox-grid'
import {
  ContainerDivs,
  AboutBanner,
  Grade,
  Link,
  LinkIcon,
  Chart,
  FlaggedFund,
  FundName,
  LegacyTobaccoGrade,
  Returns,
  InlineSignup,
  IyvScorecard
} from '../../components'
import ReactTooltip from 'react-tooltip'

const Styles = require('./FundTobaccoInvestments.css')
// const MaxPerPage = 5
const FirstPage = 5
const AllPage = 1000000

import * as searchActions from 'redux/modules/search'

function mapFundHoldings(fHoldings){
  const fHoldingsMap = {}
  fHoldings.forEach((fholding)=>{
    fHoldingsMap[fholding.db_holding_id] = fholding
  })
  return fHoldingsMap
}

function filterHoldings(fHoldingsMap, holdings, filterFn){
  return chain(holdings)
  .filter(filterFn)
  .sortBy((o)=>{
    return fHoldingsMap[o.id].market_value * -1
  })
  // .take(10)
  .value()
}

@connect(
  state => ({
    result: state.shareClass.result,
    loading: state.shareClass.loading,
    loaded: state.shareClass.loaded,
    error: state.shareClass.error
  }),
  searchActions)
@asyncConnect([{
  // need otherwise cient navigate is blocked until the page is loaded
  deferred: true,
  promise: ({params, store: {dispatch, getState}}) => {
    return dispatch(
      searchActions.shareClassDetails(
        params.fundId,
        params.investmentVehicleId
      )
    )
  }
}])
@CSSModules(Styles, {allowMultiple:true})
export default class FundTobaccoInvestments extends Component {
  static propTypes = {
    loading: PropTypes.bool,
    loaded: PropTypes.bool,
    error: PropTypes.object,
    result: PropTypes.object,
  }
  static contextTypes =  {
    router: PropTypes.object.isRequired
  }
  constructor(props) {
    super(props)
    this.state = {
      // openModal: false,
      toPage: 1,
      tmPage: 1,
      viewMore: false,
      // openModalShown: false,
    }
  }
  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll)
    analytics.event(analytics.eventLoadFund(
      this.props.params.fundId,
      this.props.params.investmentVehicleId)
    )
  }

  handleScroll = () => {
    if( !this.props.result ){ return }
  }
  // need this solution since asyncConnect and anchor links does not play nice
  scrollTo = (id) =>{
    return () =>{
      const ele = document.getElementById(id)
      window.scrollTo(ele.offsetLeft,ele.offsetTop)
    }
  }

  clickViewMore = () =>{
    this.setState({viewMore: !this.state.viewMore})
  }

  increment = (incState) => {
    return () => {
      const newState = {}
      newState[incState] = this.state[incState] + 1
      this.setState( newState )
    }
  }

  holdingsCount = ( count ) => {
    if (count > 0) {
      return format.number(count) + ' HOLDINGS'
    }
    return ''
  }

  hasEngagementStatement = (name, sri) => {
    const engagementFamily = config.engagementFunds.find(
      (family) => family.name === name
    )

    // we're done if it's not an engagement family
    if(!engagementFamily){
      return null
    }
    // otherwise, check for SRI
    // only show the statement if family is engager, has statement,
    // and fund is SRI
    return engagementFamily.statement && convert.boolean(sri)
  }

  renderGradeBox = (name, grade_tobacco, sri) => {
    // values
    const hasEngagementBadge = convert.float(grade_tobacco) === 1.5
    const letterGrade = format.score(grade_tobacco)
    const sfGrade = letterGrade === 'N/A' ? 'NA' : letterGrade
    const descriptions = {
      A: 'No holdings flagged for our tobacco screens. Assigned a grade of A.',
      E: 'Err-e',
      B: 'Fund is invested in tobacco-promoting entertainment companies, but no holdings flagged for our tobacco producer screen. Assigned a grade of B.',
      C: 'Fund is invested in tobacco producers, below the threshold of 0.5%. Assigned a grade of C.',
      D: 'Fund is invested in tobacco producers, above the threshold of 0.5% and below 1.2%. Assigned a grade of D.',
      F: 'Fund is invested in tobacco producers, above the threshold of 1.2%. Assigned a grade of F.',
      NA: 'Error',
    }
    const description = descriptions[sfGrade]

    return (
      <div styleName='grade-snapshot'>
        { /* display engagement grade or letter grade */
          convert.boolean(hasEngagementBadge) ?
            (
              <div styleName='grade-intro'>
                <strong>Tobacco engagement grade:</strong> This special
                grade is only given to funds offered by an
                asset manager with a proven track record of engaging the
                companies it invests in to push for better corporate
                behavior.
                <br/>
                <Link
                  xstrong
                  to={config.routes.faq+'#5'}
                  title='FAQ: What are socially responsible funds?'
                >
                  Learn more about fund engagement and sustainable
                  investing<LinkIcon />
                </Link>
              </div>
            ) :
            (
              <div styleName='grade-intro'>
                <strong>Tobacco grade:</strong> {description}
                <br/>
                <Link
                  xstrong
                  to={config.routes.faq+'#4'}
                  title='FAQ: Where does the "Tobacco Grade" come from?'
                >How we track tobacco investments<LinkIcon /></Link>
              </div>
            )
        }
        <div styleName='grade-wrapper'>
          <Grade grade={grade_tobacco} large/>
        </div>
        { /* <ReactTooltip/> */ }
      </div>
    )
  }

  renderUssifBadge = () => {
    // images
    const ussifLogo = require( '../../../static/images/ussif-logo.png' )

    // values
    const usfLbl = 'Member of The Forum for Sustainable and Responsible ' +
      'Investment icon'
    const usfLbl2 = 'US-SIF: Forum for Sustainable and Responsible ' +
      'Investment'

    return (
      <div styleName='ussif-badge-inner'>
        <div styleName='ussif-img-wrap'>
          <img
            styleName='ussif-badge-img'
            src={ussifLogo}
            alt={usfLbl}
          />
        </div>
        <div styleName='ussif-badge-info'>
          <div styleName='ussif-info-title'>
            Member of the Forum for Sustainable and Responsible Investment
          </div>
          <div>
            This asset manager is a member of the Forum for Sustainable and
            Responsible Investment, a group advancing sustainable,
            responsible, and impact investing.
          </div>
          <div styleName='ussif-info-subtitle'>
            Learn more: <Link
              to={config.links.ussif}
              xstrong
              title={usfLbl2}
            >Forum for Sustainable and Responsible Investment</Link>
          </div>
        </div>
      </div>
    )
  }

  renderUssifTobaccoPolicy = (policy) => {
    // images
    const tobaccoPolicyExclusionIcon = require(
      '../../../static/images/tobacco-policy-exclusion.svg'
    )
    const tobaccoPolicyResctrictedIcon = require(
      '../../../static/images/tobacco-policy-restricted.svg'
    )
    const tobaccoPolicyNoneIcon = require(
      '../../../static/images/tobacco-policy-none.svg'
    )
    // values
    const asOfDate = 'August 30, 2020'
    const usfLbl = 'US-SIF: Forum for Sustainable and Responsible Investment'

    // let policy

    return (
      <div styleName='ussif-policy-container'>
        {
          policy === 'X' ?
            (
              <div styleName='ussif-policy-inner'>
                <div styleName='ussif-img-wrap'>
                  <img
                    styleName='ussif-policy-img'
                    src={tobaccoPolicyExclusionIcon}
                    alt='Tobacco Exclusion Policy'
                  />
                </div>
                <div styleName='ussif-policy-info'>
                  <div styleName='ussif-info-title'>
                    Tobacco Exclusion Policy
                  </div>
                  <div>
                    This fund has a policy to exclude investments in companies
                    involved in the production, licensing, and/or retailing of
                    tobacco products, or in the manufacturing of products
                    necessary for production of tobacco products.
                  </div>
                  <div styleName='ussif-info-subtitle'>
                    As of {asOfDate}
                  </div>
                  <div styleName='ussif-info-subtitle'>
                    Source: <Link
                      to={config.links.ussifChart}
                      xstrong
                      title={usfLbl}
                    >US-SIF Sustainable and Responsible Mutual Fund
                    Chart</Link>
                  </div>
                </div>
              </div>
            ) :
            null
        }
        {
          policy === 'R' ?
            (
              <div styleName='ussif-policy-inner'>
                <div styleName='ussif-img-wrap'>
                  <img
                    styleName='ussif-policy-img'
                    src={tobaccoPolicyResctrictedIcon}
                    alt='Tobacco Restriction Policy'
                  />
                </div>
                <div styleName='ussif-policy-info'>
                  <div styleName='ussif-info-title'>
                    Tobacco Restriction Policy
                  </div>
                  <div>
                    This fund has a policy to restrict investments in
                    companies involved in the production, licensing, and/or
                    retailing of tobacco products, or in the manufacturing of
                    products necessary for production of tobacco products.
                  </div>
                  <div styleName='ussif-info-subtitle'>
                    As of {asOfDate}
                  </div>
                  <div styleName='ussif-info-subtitle'>
                    Source: <Link
                      to={config.links.ussifChart}
                      xstrong
                      title={usfLbl}
                    >US-SIF Sustainable and Responsible Mutual Fund
                    Chart</Link>
                  </div>
                </div>
              </div>
            ) :
            null
        }
        {
          policy === '--' ?
            (
              <div styleName='ussif-policy-inner'>
                <div styleName='ussif-img-wrap'>
                  <img
                    styleName='ussif-policy-img'
                    src={tobaccoPolicyNoneIcon}
                    alt='No Tobacco Exclusion or Restriction Policy'
                  />
                </div>
                <div styleName='ussif-policy-info'>
                  <div styleName='ussif-info-title-disabled'>
                    No Tobacco Exclusion or Restriction Policy
                  </div>
                  <div>
                    This fund is a member of US-SIF, but does not have an
                    active policy to exclude or restrict investments in
                    companies involved in the production, licensing, and/or
                    retailing of tobacco products, or in the manufacturing of
                    products necessary for production of tobacco products.
                  </div>
                  <div styleName='ussif-info-subtitle'>
                    As of {asOfDate}
                  </div>
                  <div styleName='ussif-info-subtitle'>
                    Source: <Link
                      to={config.links.ussifChart}
                      xstrong
                      title={usfLbl}
                    >US-SIF Sustainable and Responsible Mutual Fund
                    Chart</Link>
                  </div>
                </div>
              </div>
            ) :
            null
        }
      </div>
    )
  }

  renderEngagementStatement = (name) => {
    // filter engagement families from config to see if this family is
    // eligible for a statement box
    const engagementFamily = config.engagementFunds.find(
      (family) => family.name === name
    )

    // exit if it's not an engagement family
    if( !engagementFamily){
      return null
    }
    // encode URI since family names have special chars
    const safeName = encodeURIComponent(engagementFamily.name)

    return (
      <div styleName='engagement-statement-container'>
        <div styleName='engagement-statement-wrapper'>
          <div styleName='engagement-statement'>
            <div styleName='engagement-statement-title'>
              This fund family submitted a statement describing their
              engagement efforts:
            </div>
            <blockquote styleName='engagement-statement-quote'>
              {engagementFamily.statement}
            </blockquote>
            <div styleName='engagement-statement-link'>
              <Link
                xstrong
                to={`${config.routes.families}?q=${safeName}`}
                title={engagementFamily.name}
              >
                See more funds from this fund family
              </Link>
            </div>
          </div>
        </div>
      </div>
      )
  }

  renderHoldings = (shareClass, fHoldingsMap, holdings, page) => {
    // no holdings found
    if (!holdings || holdings.length === 0) {
      return (
        <div styleName='holdings-none'>NONE</div>
      )
    }

    // values
    const takeCount = (page > 1) ? AllPage : FirstPage

    return chain(holdings)
    .take(takeCount)
    .map((holding,idx) => {
      return (
        <li key={idx} styleName='holding'>
          <div styleName='holding-name'>
            {idx+1}. {holding.security_name}
          </div>
          <div styleName='holding-asset'>
            {format.perc(fHoldingsMap[holding.id].long_weight)} of portfolio
          </div>
          <div styleName='holding-invested'>
            {
              format.money(
                fHoldingsMap[holding.id].market_value,
                true,
                shareClass.currency,
                true
              )
            } invested
          </div>
        </li>
      )
    })
    .value()
  }

  renderCompanies = (shareClass, fHoldingsMap, type, label, count, holdings, page) => {
    // images
    const iconLabel = { 'to':'cigarette', 'tm':'cinema' }[type]
    const tXIcon = require('../../../static/images/icon-'+iconLabel+'.svg')

    // values
    const _count = convert.int(count)
    const hasMoreButton = (page === 1 && _count > FirstPage) ?
      (
        <div
          styleName={'detail-more-' + type}
          onClick={this.increment(type + 'Page')}
        >
          See all<LinkIcon faclass='fa-angle-down'/>
        </div>
      ) :
      null

    // no holdings found
    if ( _count === 0) {
      return (
        <Col xs={12} styleName='detail-holdings-wrapper'>
          <div styleName='detail-wrapper-empty'>
            <img
              styleName='detail-icon-empty'
              src={tXIcon}
              alt={label+' icon'}
            />
            <div styleName='detail-title-empty'>
              {label}
            </div>
            <div styleName='detail-holdings-empty'>
              0 holdings
            </div>
          </div>
        </Col>
      )
    }

    return (
      <Col xs={12} styleName='detail-holdings-wrapper'>
        <div styleName={'detail-'+type}>
          <img
            styleName='to-icon'
            src={tXIcon}
            alt={label+' icon'}
          />
          <div styleName='detail-title-holdings'>
            <div styleName={'detail-title-'+type}>
              {label}
            </div>
            <div
              styleName={
                'visible-sm visible-md visible-lg detail-holdings-count-'+type
              }
            >
              {this.holdingsCount(_count)}
            </div>
          </div>
          <div styleName='visible-xs mobile-holdings-label'>
            {_count} holdings
          </div>
          <SlideDown>
            <ul styleName='detail-holdings'>
              {this.renderHoldings(shareClass,fHoldingsMap,holdings, page)}
            </ul>
          </SlideDown>
        </div>
        {hasMoreButton}
      </Col>
    )
  }

  renderStats = (shareClass) => {
    function renderCol( type, entries, hasLine ) {
      return (
        <Col xs={6} styleName={'col-'+type+'-wrapper'}>
          {
            entries.map((entry,idx) => {
              return (
                <div key={idx} styleName='col-label-value'>
                  <div styleName={'col-'+type}>
                    <div styleName='stats-label'>
                      {entry.name}
                    </div>
                    {
                      entry.link ?
                        (
                          <Link to={entry.link} title={entry.name}>
                            <div styleName='stats-value-link'>
                              {entry.value}
                            </div>
                          </Link> 
                        ) :
                        ( 
                          <div styleName='stats-value'>
                            {entry.value}
                          </div> 
                        )
                    }
                  </div>
                  {
                    hasLine && idx !== entries.length-1 ?
                      (
                        <div styleName='col-line'/>
                      ) :
                      null
                  }
                </div>
              )
            })
          }
        </Col>
      )
    }
    // values
    const { tobacco_overall_rating, grade_tobacco } = shareClass
    // encode URI since family names have special chars
    const safeFam = encodeURIComponent(shareClass.fund_family_name)

    return (
      <div styleName='stats'>
        <div styleName='stats-inner'>
          <Row styleName='stats-header'>
            <Col xs={6}>
              <div styleName='stats-title'>
                Mutual fund profile
              </div>
            </Col>
            {
              grade_tobacco ?
               (
                  <Col xs={6}>
                    <div styleName='stats-score-label-score'>
                      <div styleName='stats-score-label'>
                        Tobacco grade
                      </div>
                      <div styleName='stats-score-wrapper'>
                        <Grade grade={grade_tobacco}/>
                      </div>
                    </div>
                  </Col>
                ) :
                null
            }
          </Row>
          <div styleName='line'/>
          <Row>
            {
              renderCol(
                'left',
                [
                  {
                    name: 'Shareclass ticker',
                    value: shareClass.ticker
                  }
                ],
                false
              )
            }
            {
              renderCol(
                'right',
                [
                  {
                    name: 'Data as of',
                    value: moment(shareClass.date.slice(0, 10)).format('D MMM YYYY')
                  }
                ],
                false
              )
            }
          </Row>
          <div styleName='line'/>
          <Row>
            {
              renderCol(
                'left',
                [
                  {
                    name: 'Shareclass name',
                    value: shareClass.name
                  }
                ],
                false
              )
            }
            {
              renderCol(
                'right',
                [
                  {
                    name: '% of Fund Assets Screened',
                    value: format.perc(shareClass.percent_rated)
                  }
                ],
                false
              )
            }
          </Row>
          <div styleName='line'/>
          <Row>
            {
              renderCol(
                'left',
                [
                  {
                    name: 'Shareclass type',
                    value: format.legalType(shareClass.legal_type)
                  }
                ],
                false
              )
            }
            {
              renderCol(
                'right',
                [
                  {
                    name: 'Fund Net Assets',
                    value: format.money(
                      shareClass.fund_net_assets,
                      true,
                      shareClass.currency
                    )
                  }
                ],
                false
                )
            }
          </Row>
          <div styleName='line'/>
          <Row>
            {
              renderCol(
                'left',
                [
                  {
                    name: 'Fund family',
                    link: `${config.routes.families}?q=${safeFam}`, 
                    value: shareClass.fund_family_name
                  }
                ],
                false
              )
            }
            {
              renderCol(
                'right',
                [
                  {
                    name: 'Fund Category',
                    value: shareClass.category_group
                  }
                ],
                false
              )
            }
          </Row>
          <div styleName='line'/>
          <Row>
            {
              renderCol(
                'left',
                [
                  {
                    name: 'Domicile country',
                    value: format.market(shareClass.market)
                  }
                ],
                false
              )
            }
            {
              renderCol(
                'right',
                [
                  {
                    name: 'Portfolio Currency',
                    value: format.currencyCode(shareClass.currency)
                  }
                ],
                false
              )
            }
          </Row>
          <div styleName='line'/>
          <Row>

            {
              renderCol(
                'left',
                [
                  {
                    name: 'Sustainable investment',
                    value: format.boolean(
                      shareClass.ussif || "0"
                    )
                  }
                ],
                false
              )
            }
            {
              renderCol(
                'right',
                [
                  {
                    name: '',
                    value: ''
                  }
                ],
                false
              )
            }
          </Row>
          <div styleName='line'/>

          <div styleName='stats-totals'>
            <div styleName='stats-totals-header'>
              Tobacco totals
            </div>
            <div styleName='stats-total'>
              <div styleName='stats-total-name'>
                Total flagged holdings for tobacco and tobacco-promoting
                entertainment companies
              </div>
              <div styleName='stats-total-value'>
                {format.number(shareClass.t_all_count)}
              </div>
            </div>
            <div styleName='stats-total'>
              <div styleName='stats-total-name'>
                Total % of fund assets flagged for tobacco and
                tobacco-promoting entertainment companies
              </div>
              <div styleName='stats-total-value'>
                {format.perc(shareClass.t_all_weight)}
              </div>
            </div>
            <div styleName='stats-total'>
              <div styleName='stats-total-name'>
                Total fund assets invested in tobacco and tobacco-promoting
                entertainment companies
              </div>
              <div styleName='stats-total-value'>
                {
                  format.money(
                    shareClass.t_all_asset,
                    true,
                    shareClass.currency,
                    false
                  )
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  renderTakeAction = (shareClass) =>{
    function renderAction(info, button, link, log) {
      return (
        <div styleName='take-action-action'>
          <div styleName='take-action-info'>
            {info}
          </div>
          <div styleName='take-action-button-wrap'>
            <Link
              to={link}
              log={log}
              title={button}
            >
              <div styleName='take-action-button'>
                {button}<LinkIcon />
              </div>
            </Link>
          </div>
        </div>
      )
    }

    const ticker = shareClass.ticker || 'N'
    const fffUrl1 = `${config.links.fffFund}/${shareClass.fund_id}/`
    const fffUrl2 = `${shareClass.investment_vehicle_id}/${ticker}`
    const fffUrl = `${fffUrl1}${fffUrl2}`

    return (
      <div styleName='take-action-wrap'>
        <div
          styleName='take-action-anchor'
          id='take-action'
        />
        <div styleName='take-action'>
          <div styleName='take-action-inner'>
            <div styleName='take-action-header'>
              Take Action
            </div>
            <div styleName='take-action-line'/>
            {
              renderAction(
                'Take action and sign our letter to the media companies',
                'Speak out',
                config.links.speakout
              )
            }
            {
              renderAction(
                'Find mutual funds that steer clear of tobacco',
                'Find tobacco free funds',
                config.routes.clean
              )
            }
            {
              renderAction(
                'Talk to your retirement plan manager about tobacco-free ' +
                  'investment options',
                'Use our toolkit',
                config.routes.toolkit,
                analytics.eventToToolkit()
              )
            }
            {
              renderAction(
                'Use FossilFreeFunds.org to see the climate impact of ' +
                  'this fund',
                'See climate impact',
                fffUrl,
                analytics.eventToFFF(
                  shareClass.fund_id,
                  shareClass.investment_vehicle_id
                )
              )
            }
          </div>
        </div>
      </div>
    )
  }

  renderMoreButton = (portfolioDate) => {
    const { viewMore } = this.state
    const label = viewMore ? 'View less' : 'View full fund profile'
    const icon = viewMore ? 'fa-angle-up' : 'fa-angle-down'
    return(
      <div styleName='view-more-wrapper'>
        <button
          styleName='view-more'
          title={label}
          onClick={this.clickViewMore}
        >
          {label}
          <LinkIcon faclass={icon}/>
        </button>
      </div>
    )
  }

  renderMore = (shareClass,showDataAs) => {
    return (
      <div styleName='more-stats'>
        {this.renderMoreButton(shareClass.date)}
        <SlideDown>
          {
            this.state.viewMore ?
              this.renderStats(shareClass) :
              null
          }
        </SlideDown>
      </div>
    )
  }

  render() {
    if (!this.props.result) {
      return (
        <div styleName='main'>
          <Loader
            options={{scale: 0.70, top:'2.0rem'}}
            loaded={false}
          />
        </div>
      )
    } else if (
      this.props.result && (
        !this.props.result.fund ||
        !this.props.result.shareClass
      )
    ) {
      this.context.router.push(config.routes.notFound)
      return (
        <div styleName='main'>
          <Loader
            options={{scale: 0.70, top:'2.0rem'}}
            loaded={false}
          />
        </div>
      )
    }
    
    function getPerc(asset,totalAsset){
      asset = convert.int(asset)
      totalAsset = convert.int(totalAsset)
      if (totalAsset === 0) {
        return 0
      }
      return convert.float((asset / totalAsset * 100).toFixed(2))
    }
    
    // images
    const toIcon = require('../../../static/images/icon-cigarette.svg')
    const tmIcon = require('../../../static/images/icon-cinema.svg')
    const magnifyIcon = require(
      '../../../static/images/icon-magnifying-glass-green.svg'
    )
    
    // objects and values
    const { shareClass, fund } = this.props.result
    const { fund_id, investment_vehicle_id } = shareClass
    const ticker = shareClass.ticker || 'N'
    const toPerc = getPerc(shareClass.to_asset, shareClass.fund_net_assets)
    const tmPerc =  getPerc(shareClass.tm_asset, shareClass.fund_net_assets)
    
    // map and filter holdings
    const fHoldingsMap = mapFundHoldings(fund.fundholdings)
    const toHoldings = filterHoldings(fHoldingsMap, fund.holdings, (h) => {
      return h.is_to
    })
    const tmHoldings = filterHoldings(fHoldingsMap, fund.holdings, (h) => {
      return h.is_tm
    })
    
    // present url
    const url1 = `${config.domain}${config.routes.fund}/`
    const url2 = `${format.sanitize(fund.fund_legal_name)}/${ticker}/`
    const url3 = `tobacco-profile/${fund_id}/${investment_vehicle_id}`
    const url = `${url1}${url2}${url3}`
    
    return (
      <div>
        {container.helmet(shareClass.fund_legal_name, url)}

        { /* FUND NAME */ }
        <FundName 
          shareClass={shareClass}
          pathname={this.props.location.pathname}
        />

        { /* FUND RESULTS CONTENT */ }
        <div styleName='main'>
          <div styleName='snapshot-wrapper'>
            <div styleName='snapshot'>

              { /* DONUT CHART */ }
              <Chart
                renderBox={CSSModules(this.renderGradeBox, Styles)}
                currency={shareClass.currency}
                invested={convert.float(shareClass.t_all_asset)}
                tmPerc={tmPerc}
                toPerc={toPerc}
                fundFamilyName={fund.fund_family_name}
                tobaccoOverallRating={fund.grade_tobacco}
                sri={convert.boolean(fund.socially_responsible_fund)}
              />
              <FlaggedFund
                count={convert.int(shareClass.t_all_count)}
                weight={convert.float(shareClass.t_all_weight)}
              />

              { /* IF USSIF: RENDER BADGES */
                convert.float(fund.ussif) === 1.5 ?
                  (
                    <Row>
                      <Col xs={12}>
                        <div styleName='ussif-wrapper'>
                          {this.renderUssifBadge()}
                          {
                            this.renderUssifTobaccoPolicy(
                              fund.tff_ussif_policy
                            )
                          }
                        </div>
                      </Col>
                    </Row>
                  ) :
                  null
              }

              { /* IF HAS ENGAGEMENT STATEMENT: RENDER */
                this.hasEngagementStatement(
                  shareClass.fund_family_name, 
                  shareClass.socially_responsible_fund
                ) ?
                  (
                    <Row>
                      <Col xs={12}>
                        {
                          this.renderEngagementStatement(
                            shareClass.fund_family_name
                          )
                        }
                      </Col>
                    </Row>
                  ) :
                  null
              }

              { /* SECTOR TOTALS */ }
              <Row>
                <Col xs={12} sm={6} styleName='detail-tobacco-wrapper'>
                  <div styleName='detail-to'>
                    <img styleName='detail-icon' src={toIcon}
                      alt='Tobacco companies'/>
                    <div styleName='detail-title'>
                      Tobacco companies
                    </div>
                    <div styleName='detail-stat'>
                      {format.number(shareClass.to_count)} holdings
                    </div>
                    <div styleName='detail-stat'>
                      {format.perc(shareClass.to_weight)} of assets
                    </div>
                    <div styleName='detail-stat'>
                      {
                        format.money(
                          shareClass.to_asset,
                          true,
                          shareClass.currency
                        )
                      } invested
                    </div>
                  </div>
                </Col>
                <Col xs={12} sm={6} styleName='detail-movies-wrapper'>
                  <div styleName='detail-tm'>
                    <img styleName='detail-icon' src={tmIcon}
                      alt='Tobacco-promoting entertainment companies'/>
                    <div styleName='detail-title'>
                      Tobacco-promoting entertainment companies
                    </div>
                    <div styleName='detail-stat'>
                      {format.number(shareClass.tm_count)} holdings
                    </div>
                    <div styleName='detail-stat'>
                      {format.perc(shareClass.tm_weight)} of assets
                    </div>
                    <div styleName='detail-stat'>
                      {
                        format.money(
                          shareClass.tm_asset,
                          true,
                          shareClass.currency
                        )
                      } invested
                    </div>
                  </div>
                </Col>
              </Row>

              { /* WHY ENTERTAINMENT COMPANIES DISCLAIMER AND CTA */ }
              <div styleName='holdings-count'>
                <div styleName='holdings-count-intro'>
                  Why entertainment companies?
                </div>
                <div styleName='holdings-count-intro-info'>
                  “R”-rating future movies with smoking will prevent one
                  million tobacco deaths in this generation of U.S. kids.
                  Hollywood studios and their parent companies, the nation’s
                  best-known entertainment companies, are well aware of the
                  public health risk, <Link
                    to={config.routes.faq+'#2'}
                    title='FAQ: Why entertainment companies?'
                    strong
                  >but continue to intentionally expose millions of
                  kids.</Link>
                </div>
                <div styleName='holdings-count-title'>
                  Tell Hollywood to rate smoking “R”
                </div>
                <div styleName='holdings-count-info'>
                  Join our call to eliminate smoking from youth-rated movies
                </div>
                <Link
                  to={config.links.speakout}
                  bigbutton
                  title={
                    'Take action: Tell Hollywood to take smoking out of ' +
                      'kid-rated movies!'
                  }
                >
                  Take action<LinkIcon />
                </Link>
              </div>

              { /* EXPOSURE TOTAL TEXT */ }
              <div styleName='holdings-count-outro'>
                This fund contains
              </div>
              <div styleName='holdings-count-stat'>
                {format.number(shareClass.t_all_count)} investments in
                tobacco producers and tobacco-promoting entertainment
                companies
              </div>

              { /* HOLDINGS LISTS + DISCLAIMER */ }
              <Row styleName='details'>
                {
                  this.renderCompanies(
                    shareClass,
                    fHoldingsMap,
                    'to',
                    'Tobacco companies',
                    shareClass.to_count,
                    toHoldings,
                    this.state.toPage
                  )
                }
                {
                  this.renderCompanies(
                    shareClass,
                    fHoldingsMap,
                    'tm',
                    'Tobacco-promoting entertainment companies',
                    shareClass.tm_count,
                    tmHoldings,
                    this.state.tmPage
                  )
                }

                { /* ENTERTAINMENT COMPANIES RATING DISCLAIMER */ }
                <Col xs={12}>
                  <div styleName='why-title'>
                    Are entertainment companies rated the same as tobacco
                    companies?
                  </div>
                  <div styleName='why-info'>
                    No - tobacco companies bear greater responsibility to the
                    tobacco epidemic, and <Link
                      to={config.routes.faq+'#4'}
                      title='FAQ: Where does the "Tobacco Grade" come from?'
                      strong
                    >our grading methodology reflects this</Link>. However,
                    the scientific consensus is that tobacco depictions in
                    movies cause kids to begin smoking. Public health impacts
                    can damage a company’s reputation and brand value,
                    decreasing long-term shareholder value. Asset managers
                    should be engaging entertainment companies by <Link
                      to={config.links.speakout}
                      title={
                        'Take action: Tell Hollywood to take smoking out ' +
                          'of kid-rated movies!'
                      }
                      strong
                    >signing investor letters</Link>, supporting shareholder
                    resolutions, or otherwise pressing entertainment companies
                    to remove smoking from youth-rated movies.
                  </div>
                </Col>
              </Row>
            </div>
          </div>

          { /* FUND INVESTMENT PROFILE SLIDEDOWN */ }
          {this.renderMore(shareClass)}

          <ContainerDivs>
            <br/>
            <br/>
            <br/>
            <InlineSignup />
            <br/>
            <br/>
            <br/>
          </ContainerDivs>

          { /* IYV REPORT CARD */ }
          <IyvScorecard fund={fund} shareClass={shareClass}/>
          
          { /* IYV RETURNS COMPONENT */ }
          { /*
          <Returns fund={fund} shareClass={shareClass} url={url}/>
          */ }

          { /* CTAS */ }
          {this.renderTakeAction(shareClass)}

          { /* ABOUT BANNER */ }
          <div styleName='banner'>
            <div styleName='banner-inner'>
              <AboutBanner />
            </div>
          </div>
        </div>
      </div>
    )
  }
}
